import React from "react"
interface FilesIconProps {
  className?: string;
}
export const FilesIcon:React.FC<FilesIconProps> = ({ className }) => {
  return (
    <div>
      <svg
        width="34"
        height="34"
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <rect width="34" height="34" rx="5" fill="#2B3467" />
        <path
          d="M13.049 11.692V13.694H8.60297V15.514H12.451V17.412H8.60297V21H6.17196V11.692H13.049ZM16.2636 14.253V21H14.0536V14.253H16.2636ZM15.1586 11.445C15.436 11.445 15.6743 11.5447 15.8736 11.744C16.073 11.9347 16.1726 12.173 16.1726 12.459C16.1726 12.7363 16.073 12.9747 15.8736 13.174C15.6743 13.3733 15.436 13.473 15.1586 13.473C14.8726 13.473 14.63 13.3733 14.4306 13.174C14.24 12.9747 14.1446 12.7363 14.1446 12.459C14.1446 12.173 14.24 11.9347 14.4306 11.744C14.63 11.5447 14.8726 11.445 15.1586 11.445ZM19.996 11.692V21H17.786V11.692H19.996ZM28.1875 18.933C28.0835 19.3317 27.8841 19.7 27.5895 20.038C26.9221 20.8007 25.9991 21.182 24.8205 21.182C23.7545 21.182 22.8921 20.8873 22.2335 20.298C21.4968 19.6393 21.1285 18.7683 21.1285 17.685C21.1285 16.5497 21.5098 15.6397 22.2725 14.955C22.9311 14.3657 23.7501 14.071 24.7295 14.071C25.9168 14.071 26.8311 14.461 27.4725 15.241C28.0358 15.9257 28.3175 16.8227 28.3175 17.932C28.3175 18.01 28.3175 18.0793 28.3175 18.14H23.2995C23.3168 18.6253 23.4598 19.0067 23.7285 19.284C23.9971 19.5527 24.3611 19.687 24.8205 19.687C25.3838 19.687 25.8128 19.4357 26.1075 18.933H28.1875ZM26.1465 16.879C26.0338 16.0037 25.5701 15.566 24.7555 15.566C23.9321 15.566 23.4555 16.0037 23.3255 16.879H26.1465Z"
          fill="white"
        />
      </svg>
    </div>
  )
}
